import { formatDistanceToNow } from 'date-fns';

const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;

export type FollowUpDueUrgency = 'upcoming' | 'soon' | 'overdue';

export function getFollowUpDueUrgency(
  iso: string,
  now: Date = new Date(),
): FollowUpDueUrgency | null {
  const due = new Date(iso);
  if (Number.isNaN(due.getTime())) return null;

  const msUntilDue = due.getTime() - now.getTime();
  if (msUntilDue <= 0) return 'overdue';
  if (msUntilDue <= TWENTY_FOUR_HOURS_MS) return 'soon';
  return 'upcoming';
}

export function getFollowUpDueBadgeLabel(iso: string, now: Date = new Date()): string {
  const due = new Date(iso);
  if (Number.isNaN(due.getTime())) return '';

  const urgency = getFollowUpDueUrgency(iso, now);
  if (urgency === 'overdue') {
    return `Due ${formatDistanceToNow(due, { addSuffix: true })}`;
  }
  return `Due in ${formatDistanceToNow(due)}`;
}

export const FOLLOW_UP_DUE_BADGE_STYLES: Record<FollowUpDueUrgency, string> = {
  upcoming: 'bg-blue-50 text-blue-700 ring-blue-100',
  soon: 'bg-amber-50 text-amber-800 ring-amber-100',
  overdue: 'bg-red-50 text-red-700 ring-red-100',
};
